module.exports = __webpack_public_path__ + "static/img/mobile_alone_en.b82c76a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_alone_en.png
// module id = 1268
// module chunks = 4